export default "__VITE_ASSET__DZdKVmkZ__"